import styled from '@emotion/styled';
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@material-ui/core';
import _Error from '@material-ui/icons/Error';
import { ChangeEvent, createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionSelectMultiple } from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import { SelectMultipleValue } from '../../../../types/DynamicSchema';
import LfToBr from '../../../primitive/LfToBr';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionSelectMultiple;
  value: SelectMultipleValue;
  errors: Array<Error>;
  onChange: (e: ChangeEvent<HTMLInputElement>, value: SelectMultipleValue) => void;
  className?: string;
};

const SelectMultipleField: FC<Props> = ({ field, value, errors, onChange, className }) => {
  const validationErrorTexts = errors.map((err) => (
    <HelperText variant="caption" color="error" key={err.message}>
      <StyledErrorIcon />

      <FormattedMessage id={`creative_brief_editor.field.validation_error.${err.message}`} />
    </HelperText>
  ));

  const items = field.choices.map((choice) => (
    <FormControlLabel
      control={
        <Checkbox
          checked={value.includes(choice.key)}
          onChange={(e, checked) =>
            onChange(e, checked ? [...value, choice.key] : value.filter((val) => val !== choice.key))
          }
        />
      }
      value={choice.key}
      label={<Typography variant="body2">{choice.label}</Typography>}
      key={choice.key}
    />
  ));

  return (
    <Base field={field} labelPaddingTop={14} className={className}>
      <div>
        <FormGroup row>{items}</FormGroup>

        {validationErrorTexts}

        <HelperText variant="caption">
          <LfToBr text={field.helperText} />
        </HelperText>
      </div>
    </Base>
  );
};

const StyledErrorIcon = styled(_Error)`
  width: 14px;
  height: 14px;
  margin-right: ${SPACING_UNIT / 2}px;
  vertical-align: bottom;
`;

const HelperText = styled(Typography)`
  margin-top: ${SPACING_UNIT}px;

  :first-of-type {
    margin-top: 0;
  }
`;

export default SelectMultipleField;
